export default __webpack_public_path__ + "static/media/dstreet-finance-logo-white.4c205173.svg";